export default __webpack_public_path__ + "static/media/carvana-final-buckle-up.52968d3c.svg";